module.exports = __webpack_public_path__ + "static/media/1_back_hp.2bb5c656.png";